import React from 'react'
import { Select as AntSelect } from 'antd'
import { StyledSelect } from './Select.styles'

const Select = ({
  input,
  meta,
  placeholder,
  options,
  allowClear,
  disabled,
  changeCallback,
}) => {
  const handleChange = (option) => {
    input.onChange(option)
    changeCallback(option)
  }
  return (
    <StyledSelect
      disabled={disabled}
      labelInValue
      invalid={meta.error}
      placeholder={placeholder}
      value={input.value || undefined} // to fix bug with placeholder's displaying
      allowClear={allowClear}
      onSelect={handleChange}
    >
      {options.map((option) => (
        <AntSelect.Option key={option.value} value={option.value}>
          {option.label}
        </AntSelect.Option>
      ))}
    </StyledSelect>
  )
}

Select.defaultProps = {
  options: [],
  allowClear: false,
  disabled: false,
}

export default Select
